'use strict';

class MainTopSettings {
	
	constructor(ngPopover, resourcePath) {
		this.ngPopover 		= ngPopover;
		this._resourcePath 	= resourcePath;
		this._settings 		= this._getSettings();
	}
	
	getIcon(action) {
		var icon = this._settings.actions[action].icon;
		return icon ? icon : 'blank'; 
	}

	getColor(action) {
		var color = this._settings.actions[action].color;
		return color ? color : 'grey-600'; 
	}

	doAction(element, params) {
		let actionObj = this._settings.actions[element.action];
		
		if (undefined !== actionObj.params)
			actionObj.params.forEach((param) => {
				params.push(param);
			});

		if(Utilities.isFunction(actionObj.action)){
			return actionObj.action(...params);
		}
	}

	doInit(element, params) {
		let actionObj = this._settings.actions[element.action];
		
		if (undefined !== actionObj.params){
			actionObj.params.forEach((param) => {
				params.push(param);
			});
		}

		if(Utilities.isFunction(actionObj.initializer)){
			actionObj.initializer(...params);
		}
	}

	_getSettings() {
		return {
			"actions": {
				"OPEN_MESSAGE_DIALOG" : {
					"action"	: openMessagesDialog
				},
				"MODELS_SECTION" : {
					"icon"		: "home",
					"color" 	: "light-green-400",
					"action"	: showModelSection
				},
				"LANDING_PAGE" : {
					"icon"		: "home",
					"color" 	: "light-green-400",
					"action"	: showLandingPage
				},
				"CREATE_MENU" : {
					"icon"	: "plus-circle",
					"color" : "deep-orange-400"
				},
				"CREATE_REPORT" : {
					"icon" 		: "view-comfy",
					"action"	: showCreateReportSection
				},
				"CREATE_DOCUMENT" : {
					"icon" 		: "dcy-document-icon",
					"action"	: showCreateDocumentSection
				},
				"CREATE_BLOG" : {
					"icon" 		: "blogger",
					"action"	: showCreateBlogSection
				},
				"CREATE_SIGNAL" : {
					"icon" 		: "share-variant",
					"action"	: openSendSignalDialog
				},
				"CREATE_TASK" : {
					"icon" 		: "clipboard-check",
					"action"	: openCreateTaskForm
				},
				"CREATE_AREA" : {
					"icon" 		: "dcy-area-icon",
					"action"	: showSpaceWizard
				},
				"CREATE_GROUP" : {
					"icon" 		: "dcy-group-icon",
					"action"	: showSpaceWizard
				},
				"CREATE_INITIATIVE" : {
					"icon" 		: "dcy-initiative-icon",
					"action"	: showSpaceWizard
				},
				"SEND_MESSAGE" : {
					"icon" 		: "email",
					"action"	: showSendMessageBox
				},

				"SPACES_GROUP" : {
					"icon" 		: "dcy-spaces-icon",
					"color"		: "blue-grey-500"
				},
				"SPACES_LIST" : {
					"action"	: showSpacesListSection
				},
				"SPACES_SECTION" : {
					"action"	: showSpacesSection
				},
				"CONTENTS_SECTION" : {
					"icon" 		: "library-books",
					"color"		: "teal-700",
					"action"	: showContentSection
				},
				"USERS_SECTION" : {
					"icon" 		: "association-500",
					"color"		: "orange-300",
					"action"	: showUsersListSection
				},

				"MANAGEMENT_GROUP" : {
					"icon" 		: "account-multiple",
					"color"		: "blue-grey-400"
				},
				"USERS_MANAGEMENT" : {
					"action"	: showUsersManagementSection
				},
				"ORGANIZATIONS_MANAGEMENT" : {
					"action"	: showOrganizationsListSection
				},
				"AUTHORIZATIONS_MANAGEMENT" : {
					"action"	: showAuthorizationGroupsSection
				},
				"STREAMS_SECTION" : {
					"icon" 		: "track_changes",
					"color"		: "blue-grey-500",
					"action"	: showStreamsSection
				},
				"WEB_DESIGNER" : {
					"icon" 		: "xml",
					"color"		: "lime-800",
					"action"	: openTemplates
				},
				"ADMINISTRATION_AREA" : {
					"icon" 		: "settings",
					"color"		: "indigo-400",
					"action"	: showAdministrationSection
				},
				"THEME_SETTINGS" : {
					"icon" 		: "format_paint",
					"color"		: "indigo-200",
					"action"	: showThemeSettingsSection
				},
				"HELP_GROUP" : {
					"icon" 		: "help-circle-outline",
					"color"		: "blue-400"
				},
				"USER_DOCS" : {
					"action"	: openHelpOnline
				},
				"ADMIN_DOCS"  : {
					"action"	: openAdminManual
				},
				"API_REST_DOCS" : {
					"action"	: openRestApiDocs
				},
				"WIDGET_SDK_DOCS": {
					"action"	: openWidgetSDKDocs
				},
				"WEB_DESIGNER_MASTERM" : {
					"icon" 		: "xml",
					"color"		: "lime-800",
					"action"	: openTemplatesMaster
				},

				"INBOX_SECTION" : {
					"icon" 		: "dcy-spaces-icon",
					"action"	: showInboxSection
				},

				"USER_PROFILE_SECTION" : {
					"icon" 		: "dcy-spaces-icon",
					"action"	: showUserProfileSection
				},
				"LOGOUT_ACTION" : {
					"icon" 		: "dcy-spaces-icon",
					"action"	: logoutFunction
				},
				"FAVOURITES" : {
					"icon" 			: "ic_star",
					"color"			: "green-400",
					"initializer"	: this._initializerFavouriteSection,
					"params"		: [this.ngPopover, this._resourcePath],
					"action"		: function() {return false;}
				},
				"RECENTS" : {
					"icon" 			: "ic_access_time",
					"color"			: "blue-900",
					"initializer"	: this._initializerRecentSection,
					"params"		: [this.ngPopover, this._resourcePath],
					"action"		: function() {return false;}
				},
				"CONTENT_ORGANIZER" : { 
					"icon" 			: "content_organizer",
					"color"			: "blue-900",
					"action"		: showContentOrganizerSection
				}
			}
		}
	}
	
	_initializerFavouriteSection(scope, target, ngPopover, resourcePath) {
		ngPopover.open(target, scope, {
			template	: 'templateFavourites',
        	placement	: 'right'
        });
	}

	_initializerRecentSection(scope, target, ngPopover, resourcePath) {
		ngPopover.open(target, scope, {
			template	: 'templateRecents',
        	placement	: 'right'
        });
	}

}